import React, { lazy, Suspense, useEffect } from "react";
import { Redirect, Switch } from "react-router-dom";
import { ContentRoute } from "./components/ContentRoute/ContentRoute";
import { LayoutSplashScreen } from "./context/LayoutContext";
import RootLayout from "./hoc/RootLayout";
import Patient from "./modules/Patients/pages";

const ProviderNotePage = lazy(() =>
  import("./modules/ProviderNote")
);

export default function BasePage({ noteId }) {

  useEffect(()=>{
    try {
    window.NUSA_initializeVuiForm();
    } catch(err) {
      console.log(err);
    }
  },[]);

  return (
    <RootLayout>
      <Suspense fallback={<LayoutSplashScreen />}>
        <Switch>
          <ContentRoute exact path="/" render={() => (
            <Redirect to={`/provider-note/${noteId}`} />)} />
          <ContentRoute exact path="/provider-note/:id" component={ProviderNotePage} />
          <ContentRoute exact path="/patient" component={Patient} />
        </Switch>
      </Suspense>
    </RootLayout>
  );
}
